import React, { FC, ReactNode } from "react";

import { GenderIcon } from "../../../../icons";

export interface IGenderBoxProps {
  title?: ReactNode | string;
}

const GenderBox: FC<IGenderBoxProps> = ({ title }) => {
  return (
    <div className="mobile-gender">
      <GenderIcon />
      {title}
    </div>
  );
};

export default GenderBox;
